import { render, staticRenderFns } from "./TopicAnswer.vue?vue&type=template&id=1553e135&"
import script from "./TopicAnswer.vue?vue&type=script&lang=js&"
export * from "./TopicAnswer.vue?vue&type=script&lang=js&"
import style0 from "./TopicAnswer.vue?vue&type=style&index=0&id=1553e135&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports